import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=4b1107d9&scoped=true&lang=pug&"
import script from "./scripts/Notice.js?vue&type=script&lang=js&"
export * from "./scripts/Notice.js?vue&type=script&lang=js&"
import style0 from "./Notice.vue?vue&type=style&index=0&id=4b1107d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1107d9",
  null
  
)

export default component.exports